"use client";
var ee = Object.defineProperty;
var te = (n, s, e) => s in n ? ee(n, s, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[s] = e;
var o = (n, s, e) => te(n, typeof s != "symbol" ? s + "" : s, e);
import { j as O } from "./jsx-runtime-CJ-St4mQ.mjs";
import { useState as G } from "react";
import re from "./Field.js";
import ne from "./Popover.js";
import { a as z, C as se } from "./Calendar-4vT_9_-G.mjs";
import ae from "./IconButton.js";
import { c as oe } from "./createLucideIcon-BjO0sRuo.mjs";
import { g as Z, t as M, c as D, m as ie, a as ce, b as ue, d as le, s as v, e as $, h as de, i as we, j as K, k as fe, l as X, n as he, w as A, o as ye, f as j } from "./format-CsCXRleo.mjs";
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xe = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }]
], be = oe("calendar", xe);
function me() {
  return Object.assign({}, Z());
}
function pe(n, s) {
  const e = M(n, s == null ? void 0 : s.in).getDay();
  return e === 0 ? 7 : e;
}
function Te(n, s) {
  const e = ge(s) ? new s(0) : D(s, 0);
  return e.setFullYear(n.getFullYear(), n.getMonth(), n.getDate()), e.setHours(
    n.getHours(),
    n.getMinutes(),
    n.getSeconds(),
    n.getMilliseconds()
  ), e;
}
function ge(n) {
  var s;
  return typeof n == "function" && ((s = n.prototype) == null ? void 0 : s.constructor) === n;
}
const De = 10;
class V {
  constructor() {
    o(this, "subPriority", 0);
  }
  validate(s, e) {
    return !0;
  }
}
class ke extends V {
  constructor(s, e, r, t, a) {
    super(), this.value = s, this.validateValue = e, this.setValue = r, this.priority = t, a && (this.subPriority = a);
  }
  validate(s, e) {
    return this.validateValue(s, this.value, e);
  }
  set(s, e, r) {
    return this.setValue(s, e, this.value, r);
  }
}
class Pe extends V {
  constructor(e, r) {
    super();
    o(this, "priority", De);
    o(this, "subPriority", -1);
    this.context = e || ((t) => D(r, t));
  }
  set(e, r) {
    return r.timestampIsSet ? e : D(e, Te(e, this.context));
  }
}
class u {
  run(s, e, r, t) {
    const a = this.parse(s, e, r, t);
    return a ? {
      setter: new ke(
        a.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: a.rest
    } : null;
  }
  validate(s, e, r) {
    return !0;
  }
}
class Me extends u {
  constructor() {
    super(...arguments);
    o(this, "priority", 140);
    o(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(e, r, t) {
    switch (r) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return t.era(e, { width: "abbreviated" }) || t.era(e, { width: "narrow" });
      // A, B
      case "GGGGG":
        return t.era(e, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return t.era(e, { width: "wide" }) || t.era(e, { width: "abbreviated" }) || t.era(e, { width: "narrow" });
    }
  }
  set(e, r, t) {
    return r.era = t, e.setFullYear(t, 0, 1), e.setHours(0, 0, 0, 0), e;
  }
}
const f = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, p = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function h(n, s) {
  return n && {
    value: s(n.value),
    rest: n.rest
  };
}
function l(n, s) {
  const e = s.match(n);
  return e ? {
    value: parseInt(e[0], 10),
    rest: s.slice(e[0].length)
  } : null;
}
function T(n, s) {
  const e = s.match(n);
  if (!e)
    return null;
  if (e[0] === "Z")
    return {
      value: 0,
      rest: s.slice(1)
    };
  const r = e[1] === "+" ? 1 : -1, t = e[2] ? parseInt(e[2], 10) : 0, a = e[3] ? parseInt(e[3], 10) : 0, i = e[5] ? parseInt(e[5], 10) : 0;
  return {
    value: r * (t * ie + a * ce + i * ue),
    rest: s.slice(e[0].length)
  };
}
function U(n) {
  return l(f.anyDigitsSigned, n);
}
function w(n, s) {
  switch (n) {
    case 1:
      return l(f.singleDigit, s);
    case 2:
      return l(f.twoDigits, s);
    case 3:
      return l(f.threeDigits, s);
    case 4:
      return l(f.fourDigits, s);
    default:
      return l(new RegExp("^\\d{1," + n + "}"), s);
  }
}
function H(n, s) {
  switch (n) {
    case 1:
      return l(f.singleDigitSigned, s);
    case 2:
      return l(f.twoDigitsSigned, s);
    case 3:
      return l(f.threeDigitsSigned, s);
    case 4:
      return l(f.fourDigitsSigned, s);
    default:
      return l(new RegExp("^-?\\d{1," + n + "}"), s);
  }
}
function L(n) {
  switch (n) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function J(n, s) {
  const e = s > 0, r = e ? s : 1 - s;
  let t;
  if (r <= 50)
    t = n || 100;
  else {
    const a = r + 50, i = Math.trunc(a / 100) * 100, y = n >= a % 100;
    t = n + i - (y ? 100 : 0);
  }
  return e ? t : 1 - t;
}
function S(n) {
  return n % 400 === 0 || n % 4 === 0 && n % 100 !== 0;
}
class _e extends u {
  constructor() {
    super(...arguments);
    o(this, "priority", 130);
    o(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(e, r, t) {
    const a = (i) => ({
      year: i,
      isTwoDigitYear: r === "yy"
    });
    switch (r) {
      case "y":
        return h(w(4, e), a);
      case "yo":
        return h(
          t.ordinalNumber(e, {
            unit: "year"
          }),
          a
        );
      default:
        return h(w(r.length, e), a);
    }
  }
  validate(e, r) {
    return r.isTwoDigitYear || r.year > 0;
  }
  set(e, r, t) {
    const a = e.getFullYear();
    if (t.isTwoDigitYear) {
      const y = J(
        t.year,
        a
      );
      return e.setFullYear(y, 0, 1), e.setHours(0, 0, 0, 0), e;
    }
    const i = !("era" in r) || r.era === 1 ? t.year : 1 - t.year;
    return e.setFullYear(i, 0, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class Ye extends u {
  constructor() {
    super(...arguments);
    o(this, "priority", 130);
    o(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(e, r, t) {
    const a = (i) => ({
      year: i,
      isTwoDigitYear: r === "YY"
    });
    switch (r) {
      case "Y":
        return h(w(4, e), a);
      case "Yo":
        return h(
          t.ordinalNumber(e, {
            unit: "year"
          }),
          a
        );
      default:
        return h(w(r.length, e), a);
    }
  }
  validate(e, r) {
    return r.isTwoDigitYear || r.year > 0;
  }
  set(e, r, t, a) {
    const i = le(e, a);
    if (t.isTwoDigitYear) {
      const b = J(
        t.year,
        i
      );
      return e.setFullYear(
        b,
        0,
        a.firstWeekContainsDate
      ), e.setHours(0, 0, 0, 0), v(e, a);
    }
    const y = !("era" in r) || r.era === 1 ? t.year : 1 - t.year;
    return e.setFullYear(y, 0, a.firstWeekContainsDate), e.setHours(0, 0, 0, 0), v(e, a);
  }
}
class Oe extends u {
  constructor() {
    super(...arguments);
    o(this, "priority", 130);
    o(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, r) {
    return H(r === "R" ? 4 : r.length, e);
  }
  set(e, r, t) {
    const a = D(e, 0);
    return a.setFullYear(t, 0, 4), a.setHours(0, 0, 0, 0), $(a);
  }
}
class Ee extends u {
  constructor() {
    super(...arguments);
    o(this, "priority", 130);
    o(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(e, r) {
    return H(r === "u" ? 4 : r.length, e);
  }
  set(e, r, t) {
    return e.setFullYear(t, 0, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class Ie extends u {
  constructor() {
    super(...arguments);
    o(this, "priority", 120);
    o(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, r, t) {
    switch (r) {
      // 1, 2, 3, 4
      case "Q":
      case "QQ":
        return w(r.length, e);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return t.ordinalNumber(e, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return t.quarter(e, {
          width: "abbreviated",
          context: "formatting"
        }) || t.quarter(e, {
          width: "narrow",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return t.quarter(e, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return t.quarter(e, {
          width: "wide",
          context: "formatting"
        }) || t.quarter(e, {
          width: "abbreviated",
          context: "formatting"
        }) || t.quarter(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(e, r) {
    return r >= 1 && r <= 4;
  }
  set(e, r, t) {
    return e.setMonth((t - 1) * 3, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class He extends u {
  constructor() {
    super(...arguments);
    o(this, "priority", 120);
    o(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, r, t) {
    switch (r) {
      // 1, 2, 3, 4
      case "q":
      case "qq":
        return w(r.length, e);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return t.ordinalNumber(e, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return t.quarter(e, {
          width: "abbreviated",
          context: "standalone"
        }) || t.quarter(e, {
          width: "narrow",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return t.quarter(e, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return t.quarter(e, {
          width: "wide",
          context: "standalone"
        }) || t.quarter(e, {
          width: "abbreviated",
          context: "standalone"
        }) || t.quarter(e, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(e, r) {
    return r >= 1 && r <= 4;
  }
  set(e, r, t) {
    return e.setMonth((t - 1) * 3, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class qe extends u {
  constructor() {
    super(...arguments);
    o(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    o(this, "priority", 110);
  }
  parse(e, r, t) {
    const a = (i) => i - 1;
    switch (r) {
      // 1, 2, ..., 12
      case "M":
        return h(
          l(f.month, e),
          a
        );
      // 01, 02, ..., 12
      case "MM":
        return h(w(2, e), a);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return h(
          t.ordinalNumber(e, {
            unit: "month"
          }),
          a
        );
      // Jan, Feb, ..., Dec
      case "MMM":
        return t.month(e, {
          width: "abbreviated",
          context: "formatting"
        }) || t.month(e, { width: "narrow", context: "formatting" });
      // J, F, ..., D
      case "MMMMM":
        return t.month(e, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return t.month(e, { width: "wide", context: "formatting" }) || t.month(e, {
          width: "abbreviated",
          context: "formatting"
        }) || t.month(e, { width: "narrow", context: "formatting" });
    }
  }
  validate(e, r) {
    return r >= 0 && r <= 11;
  }
  set(e, r, t) {
    return e.setMonth(t, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class ve extends u {
  constructor() {
    super(...arguments);
    o(this, "priority", 110);
    o(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, r, t) {
    const a = (i) => i - 1;
    switch (r) {
      // 1, 2, ..., 12
      case "L":
        return h(
          l(f.month, e),
          a
        );
      // 01, 02, ..., 12
      case "LL":
        return h(w(2, e), a);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return h(
          t.ordinalNumber(e, {
            unit: "month"
          }),
          a
        );
      // Jan, Feb, ..., Dec
      case "LLL":
        return t.month(e, {
          width: "abbreviated",
          context: "standalone"
        }) || t.month(e, { width: "narrow", context: "standalone" });
      // J, F, ..., D
      case "LLLLL":
        return t.month(e, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return t.month(e, { width: "wide", context: "standalone" }) || t.month(e, {
          width: "abbreviated",
          context: "standalone"
        }) || t.month(e, { width: "narrow", context: "standalone" });
    }
  }
  validate(e, r) {
    return r >= 0 && r <= 11;
  }
  set(e, r, t) {
    return e.setMonth(t, 1), e.setHours(0, 0, 0, 0), e;
  }
}
function Le(n, s, e) {
  const r = M(n, e == null ? void 0 : e.in), t = de(r, e) - s;
  return r.setDate(r.getDate() - t * 7), M(r, e == null ? void 0 : e.in);
}
class Ne extends u {
  constructor() {
    super(...arguments);
    o(this, "priority", 100);
    o(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(e, r, t) {
    switch (r) {
      case "w":
        return l(f.week, e);
      case "wo":
        return t.ordinalNumber(e, { unit: "week" });
      default:
        return w(r.length, e);
    }
  }
  validate(e, r) {
    return r >= 1 && r <= 53;
  }
  set(e, r, t, a) {
    return v(Le(e, t, a), a);
  }
}
function Qe(n, s, e) {
  const r = M(n, e == null ? void 0 : e.in), t = we(r, e) - s;
  return r.setDate(r.getDate() - t * 7), r;
}
class Ce extends u {
  constructor() {
    super(...arguments);
    o(this, "priority", 100);
    o(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, r, t) {
    switch (r) {
      case "I":
        return l(f.week, e);
      case "Io":
        return t.ordinalNumber(e, { unit: "week" });
      default:
        return w(r.length, e);
    }
  }
  validate(e, r) {
    return r >= 1 && r <= 53;
  }
  set(e, r, t) {
    return $(Qe(e, t));
  }
}
const Re = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], We = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class Be extends u {
  constructor() {
    super(...arguments);
    o(this, "priority", 90);
    o(this, "subPriority", 1);
    o(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, r, t) {
    switch (r) {
      case "d":
        return l(f.date, e);
      case "do":
        return t.ordinalNumber(e, { unit: "date" });
      default:
        return w(r.length, e);
    }
  }
  validate(e, r) {
    const t = e.getFullYear(), a = S(t), i = e.getMonth();
    return a ? r >= 1 && r <= We[i] : r >= 1 && r <= Re[i];
  }
  set(e, r, t) {
    return e.setDate(t), e.setHours(0, 0, 0, 0), e;
  }
}
class Fe extends u {
  constructor() {
    super(...arguments);
    o(this, "priority", 90);
    o(this, "subpriority", 1);
    o(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, r, t) {
    switch (r) {
      case "D":
      case "DD":
        return l(f.dayOfYear, e);
      case "Do":
        return t.ordinalNumber(e, { unit: "date" });
      default:
        return w(r.length, e);
    }
  }
  validate(e, r) {
    const t = e.getFullYear();
    return S(t) ? r >= 1 && r <= 366 : r >= 1 && r <= 365;
  }
  set(e, r, t) {
    return e.setMonth(0, t), e.setHours(0, 0, 0, 0), e;
  }
}
function N(n, s, e) {
  var _, P, Y, x;
  const r = Z(), t = (e == null ? void 0 : e.weekStartsOn) ?? ((P = (_ = e == null ? void 0 : e.locale) == null ? void 0 : _.options) == null ? void 0 : P.weekStartsOn) ?? r.weekStartsOn ?? ((x = (Y = r.locale) == null ? void 0 : Y.options) == null ? void 0 : x.weekStartsOn) ?? 0, a = M(n, e == null ? void 0 : e.in), i = a.getDay(), b = (s % 7 + 7) % 7, g = 7 - t, k = s < 0 || s > 6 ? s - (i + g) % 7 : (b + g) % 7 - (i + g) % 7;
  return z(a, k, e);
}
class Ge extends u {
  constructor() {
    super(...arguments);
    o(this, "priority", 90);
    o(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(e, r, t) {
    switch (r) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return t.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || t.day(e, { width: "short", context: "formatting" }) || t.day(e, { width: "narrow", context: "formatting" });
      // T
      case "EEEEE":
        return t.day(e, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return t.day(e, { width: "short", context: "formatting" }) || t.day(e, { width: "narrow", context: "formatting" });
      // Tuesday
      case "EEEE":
      default:
        return t.day(e, { width: "wide", context: "formatting" }) || t.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || t.day(e, { width: "short", context: "formatting" }) || t.day(e, { width: "narrow", context: "formatting" });
    }
  }
  validate(e, r) {
    return r >= 0 && r <= 6;
  }
  set(e, r, t, a) {
    return e = N(e, t, a), e.setHours(0, 0, 0, 0), e;
  }
}
class Xe extends u {
  constructor() {
    super(...arguments);
    o(this, "priority", 90);
    o(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, r, t, a) {
    const i = (y) => {
      const b = Math.floor((y - 1) / 7) * 7;
      return (y + a.weekStartsOn + 6) % 7 + b;
    };
    switch (r) {
      // 3
      case "e":
      case "ee":
        return h(w(r.length, e), i);
      // 3rd
      case "eo":
        return h(
          t.ordinalNumber(e, {
            unit: "day"
          }),
          i
        );
      // Tue
      case "eee":
        return t.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || t.day(e, { width: "short", context: "formatting" }) || t.day(e, { width: "narrow", context: "formatting" });
      // T
      case "eeeee":
        return t.day(e, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return t.day(e, { width: "short", context: "formatting" }) || t.day(e, { width: "narrow", context: "formatting" });
      // Tuesday
      case "eeee":
      default:
        return t.day(e, { width: "wide", context: "formatting" }) || t.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || t.day(e, { width: "short", context: "formatting" }) || t.day(e, { width: "narrow", context: "formatting" });
    }
  }
  validate(e, r) {
    return r >= 0 && r <= 6;
  }
  set(e, r, t, a) {
    return e = N(e, t, a), e.setHours(0, 0, 0, 0), e;
  }
}
class Ae extends u {
  constructor() {
    super(...arguments);
    o(this, "priority", 90);
    o(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(e, r, t, a) {
    const i = (y) => {
      const b = Math.floor((y - 1) / 7) * 7;
      return (y + a.weekStartsOn + 6) % 7 + b;
    };
    switch (r) {
      // 3
      case "c":
      case "cc":
        return h(w(r.length, e), i);
      // 3rd
      case "co":
        return h(
          t.ordinalNumber(e, {
            unit: "day"
          }),
          i
        );
      // Tue
      case "ccc":
        return t.day(e, {
          width: "abbreviated",
          context: "standalone"
        }) || t.day(e, { width: "short", context: "standalone" }) || t.day(e, { width: "narrow", context: "standalone" });
      // T
      case "ccccc":
        return t.day(e, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return t.day(e, { width: "short", context: "standalone" }) || t.day(e, { width: "narrow", context: "standalone" });
      // Tuesday
      case "cccc":
      default:
        return t.day(e, { width: "wide", context: "standalone" }) || t.day(e, {
          width: "abbreviated",
          context: "standalone"
        }) || t.day(e, { width: "short", context: "standalone" }) || t.day(e, { width: "narrow", context: "standalone" });
    }
  }
  validate(e, r) {
    return r >= 0 && r <= 6;
  }
  set(e, r, t, a) {
    return e = N(e, t, a), e.setHours(0, 0, 0, 0), e;
  }
}
function je(n, s, e) {
  const r = M(n, e == null ? void 0 : e.in), t = pe(r, e), a = s - t;
  return z(r, a, e);
}
class ze extends u {
  constructor() {
    super(...arguments);
    o(this, "priority", 90);
    o(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, r, t) {
    const a = (i) => i === 0 ? 7 : i;
    switch (r) {
      // 2
      case "i":
      case "ii":
        return w(r.length, e);
      // 2nd
      case "io":
        return t.ordinalNumber(e, { unit: "day" });
      // Tue
      case "iii":
        return h(
          t.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || t.day(e, {
            width: "short",
            context: "formatting"
          }) || t.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
      // T
      case "iiiii":
        return h(
          t.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
      // Tu
      case "iiiiii":
        return h(
          t.day(e, {
            width: "short",
            context: "formatting"
          }) || t.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
      // Tuesday
      case "iiii":
      default:
        return h(
          t.day(e, {
            width: "wide",
            context: "formatting"
          }) || t.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || t.day(e, {
            width: "short",
            context: "formatting"
          }) || t.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
    }
  }
  validate(e, r) {
    return r >= 1 && r <= 7;
  }
  set(e, r, t) {
    return e = je(e, t), e.setHours(0, 0, 0, 0), e;
  }
}
class Ze extends u {
  constructor() {
    super(...arguments);
    o(this, "priority", 80);
    o(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(e, r, t) {
    switch (r) {
      case "a":
      case "aa":
      case "aaa":
        return t.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || t.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return t.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return t.dayPeriod(e, {
          width: "wide",
          context: "formatting"
        }) || t.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || t.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(e, r, t) {
    return e.setHours(L(t), 0, 0, 0), e;
  }
}
class $e extends u {
  constructor() {
    super(...arguments);
    o(this, "priority", 80);
    o(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(e, r, t) {
    switch (r) {
      case "b":
      case "bb":
      case "bbb":
        return t.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || t.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return t.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return t.dayPeriod(e, {
          width: "wide",
          context: "formatting"
        }) || t.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || t.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(e, r, t) {
    return e.setHours(L(t), 0, 0, 0), e;
  }
}
class Ke extends u {
  constructor() {
    super(...arguments);
    o(this, "priority", 80);
    o(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(e, r, t) {
    switch (r) {
      case "B":
      case "BB":
      case "BBB":
        return t.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || t.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return t.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return t.dayPeriod(e, {
          width: "wide",
          context: "formatting"
        }) || t.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || t.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(e, r, t) {
    return e.setHours(L(t), 0, 0, 0), e;
  }
}
class Ve extends u {
  constructor() {
    super(...arguments);
    o(this, "priority", 70);
    o(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(e, r, t) {
    switch (r) {
      case "h":
        return l(f.hour12h, e);
      case "ho":
        return t.ordinalNumber(e, { unit: "hour" });
      default:
        return w(r.length, e);
    }
  }
  validate(e, r) {
    return r >= 1 && r <= 12;
  }
  set(e, r, t) {
    const a = e.getHours() >= 12;
    return a && t < 12 ? e.setHours(t + 12, 0, 0, 0) : !a && t === 12 ? e.setHours(0, 0, 0, 0) : e.setHours(t, 0, 0, 0), e;
  }
}
class Ue extends u {
  constructor() {
    super(...arguments);
    o(this, "priority", 70);
    o(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(e, r, t) {
    switch (r) {
      case "H":
        return l(f.hour23h, e);
      case "Ho":
        return t.ordinalNumber(e, { unit: "hour" });
      default:
        return w(r.length, e);
    }
  }
  validate(e, r) {
    return r >= 0 && r <= 23;
  }
  set(e, r, t) {
    return e.setHours(t, 0, 0, 0), e;
  }
}
class Je extends u {
  constructor() {
    super(...arguments);
    o(this, "priority", 70);
    o(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(e, r, t) {
    switch (r) {
      case "K":
        return l(f.hour11h, e);
      case "Ko":
        return t.ordinalNumber(e, { unit: "hour" });
      default:
        return w(r.length, e);
    }
  }
  validate(e, r) {
    return r >= 0 && r <= 11;
  }
  set(e, r, t) {
    return e.getHours() >= 12 && t < 12 ? e.setHours(t + 12, 0, 0, 0) : e.setHours(t, 0, 0, 0), e;
  }
}
class Se extends u {
  constructor() {
    super(...arguments);
    o(this, "priority", 70);
    o(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(e, r, t) {
    switch (r) {
      case "k":
        return l(f.hour24h, e);
      case "ko":
        return t.ordinalNumber(e, { unit: "hour" });
      default:
        return w(r.length, e);
    }
  }
  validate(e, r) {
    return r >= 1 && r <= 24;
  }
  set(e, r, t) {
    const a = t <= 24 ? t % 24 : t;
    return e.setHours(a, 0, 0, 0), e;
  }
}
class et extends u {
  constructor() {
    super(...arguments);
    o(this, "priority", 60);
    o(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(e, r, t) {
    switch (r) {
      case "m":
        return l(f.minute, e);
      case "mo":
        return t.ordinalNumber(e, { unit: "minute" });
      default:
        return w(r.length, e);
    }
  }
  validate(e, r) {
    return r >= 0 && r <= 59;
  }
  set(e, r, t) {
    return e.setMinutes(t, 0, 0), e;
  }
}
class tt extends u {
  constructor() {
    super(...arguments);
    o(this, "priority", 50);
    o(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(e, r, t) {
    switch (r) {
      case "s":
        return l(f.second, e);
      case "so":
        return t.ordinalNumber(e, { unit: "second" });
      default:
        return w(r.length, e);
    }
  }
  validate(e, r) {
    return r >= 0 && r <= 59;
  }
  set(e, r, t) {
    return e.setSeconds(t, 0), e;
  }
}
class rt extends u {
  constructor() {
    super(...arguments);
    o(this, "priority", 30);
    o(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(e, r) {
    const t = (a) => Math.trunc(a * Math.pow(10, -r.length + 3));
    return h(w(r.length, e), t);
  }
  set(e, r, t) {
    return e.setMilliseconds(t), e;
  }
}
class nt extends u {
  constructor() {
    super(...arguments);
    o(this, "priority", 10);
    o(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(e, r) {
    switch (r) {
      case "X":
        return T(
          p.basicOptionalMinutes,
          e
        );
      case "XX":
        return T(p.basic, e);
      case "XXXX":
        return T(
          p.basicOptionalSeconds,
          e
        );
      case "XXXXX":
        return T(
          p.extendedOptionalSeconds,
          e
        );
      case "XXX":
      default:
        return T(p.extended, e);
    }
  }
  set(e, r, t) {
    return r.timestampIsSet ? e : D(
      e,
      e.getTime() - K(e) - t
    );
  }
}
class st extends u {
  constructor() {
    super(...arguments);
    o(this, "priority", 10);
    o(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(e, r) {
    switch (r) {
      case "x":
        return T(
          p.basicOptionalMinutes,
          e
        );
      case "xx":
        return T(p.basic, e);
      case "xxxx":
        return T(
          p.basicOptionalSeconds,
          e
        );
      case "xxxxx":
        return T(
          p.extendedOptionalSeconds,
          e
        );
      case "xxx":
      default:
        return T(p.extended, e);
    }
  }
  set(e, r, t) {
    return r.timestampIsSet ? e : D(
      e,
      e.getTime() - K(e) - t
    );
  }
}
class at extends u {
  constructor() {
    super(...arguments);
    o(this, "priority", 40);
    o(this, "incompatibleTokens", "*");
  }
  parse(e) {
    return U(e);
  }
  set(e, r, t) {
    return [D(e, t * 1e3), { timestampIsSet: !0 }];
  }
}
class ot extends u {
  constructor() {
    super(...arguments);
    o(this, "priority", 20);
    o(this, "incompatibleTokens", "*");
  }
  parse(e) {
    return U(e);
  }
  set(e, r, t) {
    return [D(e, t), { timestampIsSet: !0 }];
  }
}
const it = {
  G: new Me(),
  y: new _e(),
  Y: new Ye(),
  R: new Oe(),
  u: new Ee(),
  Q: new Ie(),
  q: new He(),
  M: new qe(),
  L: new ve(),
  w: new Ne(),
  I: new Ce(),
  d: new Be(),
  D: new Fe(),
  E: new Ge(),
  e: new Xe(),
  c: new Ae(),
  i: new ze(),
  a: new Ze(),
  b: new $e(),
  B: new Ke(),
  h: new Ve(),
  H: new Ue(),
  K: new Je(),
  k: new Se(),
  m: new et(),
  s: new tt(),
  S: new rt(),
  X: new nt(),
  x: new st(),
  t: new at(),
  T: new ot()
}, ct = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, ut = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, lt = /^'([^]*?)'?$/, dt = /''/g, wt = /\S/, ft = /[a-zA-Z]/;
function ht(n, s, e, r) {
  var I, Q, C, R;
  const t = () => D(e, NaN), a = me(), i = a.locale ?? fe, y = a.firstWeekContainsDate ?? ((Q = (I = a.locale) == null ? void 0 : I.options) == null ? void 0 : Q.firstWeekContainsDate) ?? 1, b = a.weekStartsOn ?? ((R = (C = a.locale) == null ? void 0 : C.options) == null ? void 0 : R.weekStartsOn) ?? 0;
  if (!s)
    return n ? t() : M(e, r == null ? void 0 : r.in);
  const g = {
    firstWeekContainsDate: y,
    weekStartsOn: b,
    locale: i
  }, k = [new Pe(r == null ? void 0 : r.in, e)], _ = s.match(ut).map((c) => {
    const d = c[0];
    if (d in X) {
      const m = X[d];
      return m(c, i.formatLong);
    }
    return c;
  }).join("").match(ct), P = [];
  for (let c of _) {
    he(c) && A(c, s, n), ye(c) && A(c, s, n);
    const d = c[0], m = it[d];
    if (m) {
      const { incompatibleTokens: W } = m;
      if (Array.isArray(W)) {
        const B = P.find(
          (F) => W.includes(F.token) || F.token === d
        );
        if (B)
          throw new RangeError(
            `The format string mustn't contain \`${B.fullToken}\` and \`${c}\` at the same time`
          );
      } else if (m.incompatibleTokens === "*" && P.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${c}\` and any other token at the same time`
        );
      P.push({ token: d, fullToken: c });
      const q = m.run(
        n,
        c,
        i.match,
        g
      );
      if (!q)
        return t();
      k.push(q.setter), n = q.rest;
    } else {
      if (d.match(ft))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + d + "`"
        );
      if (c === "''" ? c = "'" : d === "'" && (c = yt(c)), n.indexOf(c) === 0)
        n = n.slice(c.length);
      else
        return t();
    }
  }
  if (n.length > 0 && wt.test(n))
    return t();
  const Y = k.map((c) => c.priority).sort((c, d) => d - c).filter((c, d, m) => m.indexOf(c) === d).map(
    (c) => k.filter((d) => d.priority === c).sort((d, m) => m.subPriority - d.subPriority)
  ).map((c) => c[0]);
  let x = M(e, r == null ? void 0 : r.in);
  if (isNaN(+x)) return t();
  const E = {};
  for (const c of Y) {
    if (!c.validate(x, g))
      return t();
    const d = c.set(x, E, g);
    Array.isArray(d) ? (x = d[0], Object.assign(E, d[1])) : x = d;
  }
  return x;
}
function yt(n) {
  return n.match(lt)[1].replace(dt, "'");
}
const Mt = (n) => {
  const {
    value: s,
    onChange: e,
    format: r = "yyyy-MM-dd",
    placeholder: t,
    label: a,
    calenderProps: i
  } = n, [y, b] = G(s || void 0), [g, k] = G(!1), _ = (x) => {
    const E = x.target.value, I = ht(E, r, /* @__PURE__ */ new Date());
    b(I);
  }, P = (x) => {
    x ? (b(x), typeof e == "function" && e(j(x, "yyyy-MM-dd"))) : b(void 0), k(!1);
  }, Y = y && !isNaN(y.getTime()) ? j(y, r) : "";
  return /* @__PURE__ */ O.jsx(
    re,
    {
      type: "text",
      label: a || "Date",
      readOnly: !0,
      className: "input-no-calendar",
      value: Y,
      onChange: _,
      placeholder: t || r,
      endAdornment: /* @__PURE__ */ O.jsx(
        ne,
        {
          className: "!p-0",
          open: g,
          onOpenChange: k,
          align: "end",
          trigger: /* @__PURE__ */ O.jsx(ae, { color: "primary", variant: "text", title: "Calender", children: /* @__PURE__ */ O.jsx(be, {}) }),
          children: /* @__PURE__ */ O.jsx(
            se,
            {
              value: y,
              onChange: P,
              className: "!shadow-none !border-none",
              ...i
            }
          )
        }
      )
    }
  );
};
export {
  Mt as default
};
